/// FOURJS_START_COPYRIGHT(D,2021)
/// Property of Four Js*
/// (c) Copyright Four Js 2021, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ApplicationListVisible4STBehavior", ["StyleBehaviorBase"], function (context, cls) {
  /**
   * Define the applicationListVisible 4ST.
   * Possible values are 'yes', 'no', 'auto'
   * @class ApplicationListVisible4STBehavior
   * @memberOf classes
   * @extends classes.StyleBehaviorBase
   */
  cls.ApplicationListVisible4STBehavior = context.oo.Singleton(cls.StyleBehaviorBase, function ($super) {
    return /** @lends classes.ApplicationListVisible4STBehavior.prototype */ {
      __name: "ApplicationListVisible4STBehavior",

      usedStyleAttributes: ["applicationListVisible"],
      /**
       * @inheritDoc
       */
      _apply: function (controller, data) {
        const node = controller?.getAnchorNode();
        let applicationListVisible = node.getStyleAttribute("applicationListVisible"); // use "auto" as default if not specified
        if (!applicationListVisible) {
          // if no style is set, use default values
          if (cls.WindowHelper.isMobile()) {
            // default value for mobile
            applicationListVisible = "no";
          } else {
            applicationListVisible = context.ApplicationListService.DefaultVisibility;
          }
        }
        context.ApplicationListService.setApplicationListVisible(applicationListVisible);
      }
    };
  });
});
